import React, { useState, useEffect } from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaShareAlt,
} from "react-icons/fa";
import { FiArrowRight, FiMapPin, FiMail, FiPhone } from "react-icons/fi";
import Header from "./Header";
import Footers from "./Footers";
import "./Contact.css";
import "./publicPages.css";
import "./catalogHero.css";
import AxiosInstance from "./AxiosInstance";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    subject: "",
    user_type: "",
    message: "",
  });

  const [statusMsg, setStatusMsg] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!statusMsg) return undefined;
    const timer = setTimeout(() => setStatusMsg(""), 10000);
    return () => clearTimeout(timer);
  }, [statusMsg]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      await AxiosInstance.post("companies/contact-form/", formData);
      setStatusMsg("Message submitted successfully!");
      setFormData({
        name: "",
        mobile: "",
        email: "",
        subject: "",
        user_type: "",
        message: "",
      });
    } catch (error) {
      console.error("Error while submitting:", error);
      setStatusMsg("An error occurred. Please try again later.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact-page d-flex flex-column min-vh-100">
      <Header />

      <div className="als-page-hero als-hero-split">
        <div className="als-page-hero-inner">
          <div className="als-hero-copy">
            <h1>Contact Us</h1>
            <p>We&apos;d love to hear from you — reach out anytime.</p>
          </div>
          <div className="als-hero-media">
            <img
              src="https://images.unsplash.com/photo-1423666639041-f56000c27a9a?w=800&h=520&fit=crop"
              alt="Contact Open Learnings"
            />
          </div>
        </div>
      </div>

      <section className="contact-body flex-grow-1">
        <div className="contact-body-inner">
          <div className="contact-grid">
            <div className="contact-info">
              <h2>We&apos;re always eager to hear from you</h2>
              <p className="contact-info-lead">
                Whether you have a question about courses, partnerships, or
                training support — our team is ready to help.
              </p>

              <div className="contact-detail">
                <span className="contact-detail-icon" aria-hidden="true">
                  <FiMapPin />
                </span>
                <div>
                  <h3>Address</h3>
                  <p>
                    #2nd Floor, Plot No. 31/B,
                    <br />
                    Road No. 4, Chaitanya Nagar, B.N. Reddy Nagar,
                    <br />
                    Hyderabad, TG, 500079
                  </p>
                </div>
              </div>

              <div className="contact-detail">
                <span className="contact-detail-icon" aria-hidden="true">
                  <FiMail />
                </span>
                <div>
                  <h3>Email</h3>
                  <p>
                    <a href="mailto:techsupport@openlearnings.online">
                      techsupport@openlearnings.online
                    </a>
                  </p>
                </div>
              </div>

              <div className="contact-detail">
                <span className="contact-detail-icon" aria-hidden="true">
                  <FiPhone />
                </span>
                <div>
                  <h3>Mobile</h3>
                  <p>
                    <a href="tel:+918142251234">+91 (814) 225 - 1234</a>
                  </p>
                </div>
              </div>

              <div className="contact-social">
                <a
                  className="contact-social-btn"
                  href="https://acharyals.com"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Website"
                >
                  <FaShareAlt />
                </a>
                <a
                  className="contact-social-btn"
                  href="https://www.facebook.com"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Facebook"
                >
                  <FaFacebookF />
                </a>
                <a
                  className="contact-social-btn"
                  href="https://twitter.com"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Twitter"
                >
                  <FaTwitter />
                </a>
                <a
                  className="contact-social-btn"
                  href="https://www.linkedin.com"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="LinkedIn"
                >
                  <FaLinkedinIn />
                </a>
              </div>
            </div>

            <div className="contact-form-card">
              <h2>Get in touch</h2>
              <p>
                Fill out this form for booking a consultant advising session.
              </p>

              <form onSubmit={handleSubmit}>
                <div className="contact-field">
                  <label htmlFor="contact-name">Name *</label>
                  <input
                    id="contact-name"
                    type="text"
                    name="name"
                    placeholder="Your name"
                    required
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
                <div className="contact-field-row">
                  <div className="contact-field">
                    <label htmlFor="contact-mobile">Mobile *</label>
                    <input
                      id="contact-mobile"
                      type="tel"
                      name="mobile"
                      placeholder="Mobile number"
                      required
                      value={formData.mobile}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="contact-field">
                    <label htmlFor="contact-email">Email *</label>
                    <input
                      id="contact-email"
                      type="email"
                      name="email"
                      placeholder="Email address"
                      required
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="contact-field">
                  <label htmlFor="contact-user-type">User type *</label>
                  <select
                    id="contact-user-type"
                    name="user_type"
                    required
                    value={formData.user_type}
                    onChange={handleChange}
                  >
                    <option value="" disabled>
                      Select user type
                    </option>
                    <option value="user">User</option>
                    <option value="trainer">Trainer</option>
                    <option value="trainee">Trainee</option>
                  </select>
                </div>
                <div className="contact-field">
                  <label htmlFor="contact-subject">Subject</label>
                  <input
                    id="contact-subject"
                    type="text"
                    name="subject"
                    placeholder="Subject"
                    value={formData.subject}
                    onChange={handleChange}
                  />
                </div>
                <div className="contact-field">
                  <label htmlFor="contact-message">Message</label>
                  <textarea
                    id="contact-message"
                    rows="4"
                    name="message"
                    placeholder="How can we help?"
                    value={formData.message}
                    onChange={handleChange}
                  />
                </div>

                <button
                  type="submit"
                  className="contact-submit"
                  disabled={submitting}
                >
                  {submitting ? "Sending…" : "Submit message"}
                  {!submitting && <FiArrowRight />}
                </button>

                {statusMsg && (
                  <p
                    className={`contact-status ${
                      statusMsg.includes("successfully") ? "ok" : "err"
                    }`}
                  >
                    {statusMsg}
                  </p>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-map">
        <div className="contact-map-inner">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4458.7825859511895!2d78.55371225014763!3d17.32002650974991!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcba323fa8b933d%3A0x8f920a263877043b!2sAcharya%20Learning%20Solutions!5e0!3m2!1sen!2sin!4v1739284920877!5m2!1sen!2sin"
            width="100%"
            height="420"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Open Learnings Location"
          />
        </div>
      </section>

      <Footers />
    </div>
  );
}
